import { initializeApp } from "firebase/app";
import {
    getAuth,
    signInWithEmailAndPassword,
    signOut as firebaseSignOut,
    onAuthStateChanged,
    type User,
} from "firebase/auth";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_IDENTITY_PLATFORM_API_KEY,
    authDomain: `${import.meta.env.VITE_GCP_PROJECT_ID}.firebaseapp.com`,
    projectId: import.meta.env.VITE_GCP_PROJECT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export async function signIn(email: string, password: string): Promise<User> {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result.user;
}

export async function signOut(): Promise<void> {
    await firebaseSignOut(auth);
}

export async function getIdToken(): Promise<string | null> {
    const user = auth.currentUser;
    if (!user) return null;
    return user.getIdToken();
}

export async function getIdTokenResult(): Promise<{
    token: string;
    claims: Record<string, unknown>;
} | null> {
    const user = auth.currentUser;
    if (!user) return null;

    const result = await user.getIdTokenResult();
    return {
        token: result.token,
        claims: result.claims as Record<string, unknown>,
    };
}

export function onAuthChange(callback: (user: User | null) => void): () => void {
    return onAuthStateChanged(auth, callback);
}

export function getCurrentUser(): User | null {
    return auth.currentUser;
}
